import {
    Box,
    Button,
    Flex,
    Grid,
    GridItem,
    Heading,
    IconButton,
    Spacer,
    Stack,
    useDisclosure,
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,
    Input,
    Center,
    Text,
    useToast,
} from "@chakra-ui/react";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import React, { useEffect, useState } from "react";
import { AiFillSave } from "react-icons/ai";
import { IoChevronBack } from "react-icons/io5";
import { MdDelete } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import CommonContext from '../../commonContext';
import DeleteForm from "../../components/DeleteForm";
import { postCall } from '../../utils/requests';
import { IoAdd, IoRemove } from "react-icons/io5";

function NewTrainingSheet() {
    const [events, setEvents] = useState([]);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [isOpenDelete, setIsOpenDelete] = useState(false);
    const [currentTraining, setCurrentTraining] = useState(null);
    const [trainings, setTrainings] = useState([]);
    const commonContext = React.useContext(CommonContext);
    const [isOpenAlertConfirm, setIsOpenAlertConfirm] = React.useState(false)
    const openAlertConfirm = () => setIsOpenAlertConfirm(true)
    const navigate = useNavigate();
    const cancelRef = React.useRef()
    const [search, setSearch] = useState("");
    const [allExercises, setAllExercises] = useState([]);
    const [daysNumber, setDaysNumber] = useState(7);
    const [sheetName, setSheetName] = useState("");
    const toast = useToast();

    const fetchExercises = async () => {


        postCall("/fetchTrainings", {}).then((data) => {

            console.log("DATA", data);

            setTrainings(Array.from(data.data.map((item) => {
                return {
                    id: item.id_training_set,
                    name: item.name,
                }
            })));

            setAllExercises(Array.from(data.data.map((item) => {
                return {
                    id: item.id_training_set,
                    name: item.name,
                }
            })));
        });
    }

    const onCloseAlertConfirm = (e) => {
        setIsOpenAlertConfirm(false)
        if (e.target.innerHTML === "Si") {
            navigate(-1)
        }
    }


    const onDelete = () => {
        setIsOpenDelete(false);
        setEvents(events.filter((event) => event.id !== currentTraining.id));
    };

    const onCloseDelete = () => {
        setIsOpenDelete(false);
    };

    const handleGoBack = () => {
        console.log("ok")
        if (events.length > 0) {
            openAlertConfirm()
        } else {
            navigate(-1)
        }
    }

    const handleSave = () => {
        console.log("EVENTS_TO_SAVE", events)

        if(sheetName === ""){
            toast({
                title: "Errore",
                description: "Inserisci un nome per la scheda",
                status: "error",
                duration: 2000,
                isClosable: true,
                position: "top"
                })
            return;
        }

        postCall("/createTrainingSheet", { events: events, sheetName: sheetName }).then((data) => {

            if(data.status === "success"){
                console.log("DATA", data);
                navigate(-1);
                toast({
                    title: "Perfetto",
                    description: "Scheda allenamento creata con successo",
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                    position: "top"
                  })
            }else{
                toast({
                    title: "Errore",
                    description: "Si è verificato un errore",
                    status: "error",
                    duration: 2000,
                    isClosable: true,
                    position: "top"
                  })
            }

        });

    }

    useEffect(() => {
        commonContext.setCurrentPath("Nuova scheda allenamento")
        commonContext.setCurrentPage("trainingsheets")
        fetchExercises();
    }, []);

    const onDragEnd = (result) => {
        if (!result.destination) return;

        console.log("result", result);

        if (result.destination.droppableId === "123456789") {
            return;
        }


        if (result.source.droppableId.toString() === "123456789") {
            const decodedId = JSON.parse(result.draggableId);

            console.log("Decoded ID:", decodedId);

            const { id, type, name } = decodedId;

            console.log("ID:", id);
            console.log("Type:", type);

            //generate random number
            const randomId = Math.floor(Math.random() * 1000000);

            setEvents(events.concat({ id: randomId + "_" + result.destination.droppableId + "_" + id, title: name, cell: result.destination.droppableId, id_training_set: id }));
        } else {
            setEvents(events.map((event) => {
                if (event.id === result.draggableId) {
                    event.cell = result.destination.droppableId;
                }
                return event;
            }))
        }

        console.log(events)
    };

    const handleCellClick = (event) => {
        //do nothing
    };

    return (
        <Box>

            <Stack pr="20px" mt="2%" ml="2" mb="10" direction='row' spacing={4} justifyContent="space-between">
                <Flex justifyContent="left" w="100%" >
                    <Button mr="20px" leftIcon={<IoChevronBack />} colorScheme='green' variant='solid' onClick={() => { handleGoBack() }}>
                        Indietro
                    </Button>
                    <Button isDisabled={events.length < 1} mr="20px" leftIcon={<AiFillSave />} colorScheme="orange" variant='solid' onClick={() => { handleSave() }}>
                        Salva
                    </Button>
                </Flex>
            </Stack>
            <Stack
                pr="20px"
                mt="2%"
                mb="10"
                direction='row'
                spacing={1}
                justifyContent="start"
                alignItems="center">
                <Text ml="20px" mr="30px">Nome scheda: </Text>
                <Input w="60%" value={sheetName}
                onChange={(e) => setSheetName(e.target.value)} ></Input>
            </Stack>
            {/* BEGIN - ALERT ask confirmation */}
            <AlertDialog
                isOpen={isOpenAlertConfirm}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlertConfirm}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            ATTENZIONE
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            Sei sicuro di voler tornare indietro senza salvare le modifiche effettuate?
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlertConfirm}>
                                No
                            </Button>
                            <Button colorScheme='red' onClick={onCloseAlertConfirm} ml={3}>
                                Si
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>

            {/* END - ALERT ask confirmation*/}
            <DeleteForm
                isOpen={isOpenDelete}
                onClose={onCloseDelete}
                onDelete={onDelete}
                alertText={`Vuoi rimuovere l'allenamento ${currentTraining ? currentTraining.title : ""}?`}
            />

            <Flex>

                <DragDropContext onDragEnd={onDragEnd}>

                    <Flex w="30%" direction="column">
                        <Input
                            ml="30px"
                            borderColor="black"
                            w="80%"
                            placeholder="Cerca..."
                            type="text"
                            value={search}
                            onChange={(event) => {
                                setSearch(event.target.value)
                                setTrainings(allExercises.filter((item) => item.name.toLowerCase().includes(event.target.value.toLowerCase())))
                            }}
                        />

                        <Box
                            mt="10px"
                            ml="30px"
                            h="70vh"
                            w="80%"
                            bg="gray.100"
                            p={4}
                            borderRadius="md"
                            overflowY={"auto"}
                        >
                            <Droppable key={"123456789"} droppableId={"123456789"}>

                                {(providedone) => (

                                    <Box
                                        ref={providedone.innerRef}
                                        {...providedone.droppableProps}
                                        bg="gray.100"
                                        p={4}
                                        borderRadius="md"

                                    >
                                        {trainings.map((train) => <Draggable index={train.id} key={train.id.toString()} draggableId={JSON.stringify({ id: train.id.toString(), type: "base", name: train.name })} >
                                            {(providedtwo) => (
                                                <Flex
                                                    ref={providedtwo.innerRef}
                                                    {...providedtwo.draggableProps}
                                                    {...providedtwo.dragHandleProps}
                                                    bg="white"
                                                    p={2}
                                                    borderRadius="md"
                                                    my={2}

                                                >
                                                    {train.name}

                                                </Flex>

                                            )}

                                        </Draggable>)}
                                        {providedone.placeholder}

                                    </Box>)}
                            </Droppable>
                        </Box>
                    </Flex>
                    <Box w="100%">
                        <Grid templateColumns="repeat(4, 1fr)" gap={6} p={6}>
                            {/* numbers from 0 to 10 */}
                            {Array.from({ length: daysNumber }, (_, index) => index).map((dayId) => (
                                <Droppable key={dayId.toString()} droppableId={dayId.toString()}>
                                    {(provided) => (
                                        <GridItem
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            bg="gray.100"
                                            p={4}
                                            borderRadius="md"
                                            onClick={() => handleCellClick(null)}
                                        >
                                            <Heading mb="20px" size="md">{"Giorno " + (parseInt(dayId) + 1)}</Heading>
                                            {events
                                                .filter((event) => event.cell === dayId.toString())
                                                .map((event, index) => (
                                                    <Draggable key={event.id} draggableId={event.id} index={index}>
                                                        {(provided) => (
                                                            <Flex
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                bg="white"
                                                                p={2}
                                                                borderRadius="md"
                                                                my={2}
                                                                onClick={() => handleCellClick(event)}
                                                            >
                                                                {event.title}
                                                                <Spacer />
                                                                <IconButton
                                                                    mr="2"
                                                                    colorScheme='red'
                                                                    aria-label='Call Segun'
                                                                    size='sm'
                                                                    icon={<MdDelete />}
                                                                    onClick={() => {
                                                                        setCurrentTraining(event);
                                                                        setIsOpenDelete(true);
                                                                    }}
                                                                />
                                                            </Flex>

                                                        )}
                                                    </Draggable>
                                                ))}
                                            {provided.placeholder}
                                        </GridItem>
                                    )}
                                </Droppable>
                            ))}
                        </Grid>
                        <Center>

                            <Button
                                mr={4}
                                colorScheme="red"
                                onClick={() => {
                                    if (daysNumber > 1) {
                                        setDaysNumber(daysNumber - 1)
                                        setEvents(events.filter((event) => event.cell !== (daysNumber - 1).toString()))

                                    }
                                }}
                            ><IoRemove></IoRemove> </Button>

                            <Button
                                colorScheme="green"
                                onClick={() => {
                                    if (daysNumber < 99) {
                                        setDaysNumber(daysNumber + 1)
                                    }
                                }}
                            ><IoAdd></IoAdd> </Button>

                        </Center>
                    </Box>
                </DragDropContext>

            </Flex>
        </Box>
    );
}

export default NewTrainingSheet;
